import Page from "../components/page";
import config from "../configs";

const Dmca = () => {
  return (
    <Page title={`DMCA - ${config.appName}`} hideLoader>
      <div className="info-page">
        <p>Here's a unique rewrite of your DMCA and disclaimer content:</p>
        <hr />
        <h3>
          <strong>DMCA Policy</strong>
        </h3>
        <p>
          We take copyright infringement seriously and adhere to the guidelines
          set by the <strong>Digital Millennium Copyright Act (DMCA)</strong>.
          If you believe that your intellectual property has been used
          unlawfully on our platform, please submit a formal{" "}
          <strong>DMCA takedown request</strong> with the necessary details.
          Your request must meet the{" "}
          <strong>DMCA notification requirements</strong> to be processed.
        </p>
        <h3>
          <strong>Required Information for a Valid DMCA Notice:</strong>
        </h3>
        <ol>
          <li>
            <p>
              <strong>Your Identity:</strong>
            </p>
            <ul>
              <li>
                You must be the <strong>copyright owner</strong> or
              </li>
              <li>
                A <strong>representative authorized</strong> to act on behalf of
                the copyright owner.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Details of the Copyrighted Work:</strong>
            </p>
            <ul>
              <li>
                Clearly specify the copyrighted material that has been infringed
                upon.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Identification of the Infringing Content:</strong>
            </p>
            <ul>
              <li>
                Provide a direct link to the infringing file (e.g., an{" "}
                <strong>interupload.com</strong> URL) and a clear description of
                the content that needs to be removed.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Website URL:</strong>
            </p>
            <ul>
              <li>
                Share the web address where the infringing link is publicly
                accessible.
              </li>
            </ul>
          </li>
          <li>
            <p>
              <strong>Your Contact Information:</strong>
            </p>
            <ul>
              <li>
                Include your{" "}
                <strong>
                  full name, physical address, and telephone number
                </strong>{" "}
                for correspondence.
              </li>
            </ul>
          </li>
        </ol>
        <p>
          For more details on valid DMCA notices, please refer to{" "}
          <strong>17 U.S.C. 512(c)(3)</strong>.
        </p>
        <p>
          ⚠ <strong>Important Notice:</strong>
          <br />
          Under the <strong>DMCA</strong>, submitting false claims of copyright
          infringement can lead to legal consequences, including financial
          liabilities, legal fees, and court costs.
        </p>
        <p>
          All DMCA notices must contain the above-mentioned details, or they may
          be <strong>disregarded</strong>.
        </p>
        <p>
          📩 <strong>Submit Your DMCA Notice:</strong> Mail us on{" "}
          <a target="_blank" href={`mailto:${config.email}`}>
            {config.email}
          </a>
        </p>
        <p>
          📌 <strong>Response Time:</strong> Please allow{" "}
          <strong>24 Hours</strong> for us to process your request. Contacting
          third parties, such as our hosting provider, will not speed up the
          process and may cause unnecessary delays.
        </p>
        <hr />
        <h3>
          <strong>Disclaimer</strong>
        </h3>
        <p>
          <strong>{config.appName}</strong> does not store or host any files on
          its servers. All content shared on this website is{" "}
          <strong>linked to third-party websites</strong>. We hold no
          responsibility for the files hosted externally and have no control
          over their availability or content.
        </p>
      </div>
    </Page>
  );
};

export default Dmca;
